import { useState } from 'react';
import { setStudentBirthYm } from '../../shared/api/birthYm';
import BirthYmPicker from './BirthYmPicker';
import './BirthYm.css';

const dismissKey = (studentId) => `birthYmPrompt:dismissed:${studentId}`;

function readDismissed(studentId) {
  try { return localStorage.getItem(dismissKey(studentId)) === '1'; } catch { return false; }
}

/**
 * A one-time card on the dashboard while a child's age is unknown, addressed to
 * the parent holding the phone. Gone for good once saved — or after 以后再说
 * (the setting stays in ⚙️ for whenever they want it).
 *
 * @param {{ studentId: string, birthYm: string|null|undefined, onSaved: (birthYm: string|null) => void }} props
 */
export default function BirthYmPrompt({ studentId, birthYm, onSaved }) {
  const [dismissed, setDismissed] = useState(() => readDismissed(studentId));

  // undefined = dashboard not loaded yet; only an explicit null means "unknown".
  if (birthYm !== null || dismissed) return null;

  const dismiss = () => {
    try { localStorage.setItem(dismissKey(studentId), '1'); } catch { /* still hide for now */ }
    setDismissed(true);
  };

  const save = async (ym) => {
    const res = await setStudentBirthYm(studentId, ym);
    onSaved(res.birthYm);
  };

  return (
    <section className="birth-ym-prompt" aria-label="填写孩子出生年月">
      <h2 className="birth-ym-prompt__title">孩子多大了？</h2>
      <p className="birth-ym-prompt__body">
        填写出生年月，每日听力会按年龄出题：小朋友听音选词，大一点用字母块拼写或打字。
      </p>
      <BirthYmPicker idPrefix="prompt-birth-ym" onSave={save} />
      <button type="button" className="birth-ym-prompt__later" onClick={dismiss}>以后再说</button>
    </section>
  );
}
